module.exports = __webpack_public_path__ + "static/media/James Frampton_DT.39d9c3db.jpg";